// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { NotificationSendLog } from './notification-send-log';
import { NotificationTemplate } from './notification-template';
import { NotificationTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class NotificationType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: NotificationTypeEnum;
  /** String(250) */
  description?: string;
  /** String(60) */
  name!: string;
  /** Inv FK notificationTypeId */
  notificationSendLogs!: NotificationSendLog[];
  /** Inv FK notificationTypeId */
  notificationTemplates!: NotificationTemplate[];
}

